export class Deferred<T = void> {
	promise: Promise<T>;

	constructor() {
		this.promise = new Promise<T>((resolve, reject) => {
			this.resolve = resolve;
			this.reject = reject;
		});
	}
	resolve: (value?: T | PromiseLike<T>) => void = () => undefined;
	reject: (value?: T | PromiseLike<T>) => void = () => undefined;
}
